import MessagingV2MediaViewer from "./MessagingV2MediaViewer";
export default MessagingV2MediaViewer;
